import { ListAddMessage } from '../../types/common/SearchResultType';
import {
    DeviceInfoRow,
    ChangeFieldItemInput,
    INIT_DEVICE_INFO_ROW,
    INIT_DEVICE_INFO_INPUT_ROW,
} from '../../types/common/EstimateInquiryType';
import { SearchItems } from '../../types/api/SearchApiType';
import { MAX_DEVICE_COUNT } from '../../types/common/CommonType';
import { Messages, ErrorMessages } from '../../types/common/Messages';

import { AppDispatch } from '../../store/store';
import { addDeviceRow } from '../../slice/EstimateInquirySlice';

// 検索結果の機器リストへの追加(モーダルにて実行)
const addSearchResultDeviceList = (
    devicecList: Array<DeviceInfoRow>,
    searchItems: SearchItems,
    modalItems: ChangeFieldItemInput,
    setListAddMessage: (values: ListAddMessage) => void,
    setErrorMessages: (values: Array<string>) => void,
    setOpenErrorModal: (value: boolean) => void,
    setAddDeviceModal: (value: boolean) => void,
    dispatch: AppDispatch
) => {
    if (devicecList.length < MAX_DEVICE_COUNT) {
        const addDeviceData: DeviceInfoRow = {
            ...INIT_DEVICE_INFO_ROW,
            makerName: searchItems.maker_name,
            modelType: searchItems.mp_model_number1 ?? '',
            modelid: searchItems.mp_id,
            modelName: searchItems.mp_product_name,
            inputList: [{ ...modalItems }],
        };
        dispatch(addDeviceRow(addDeviceData));

        // 追加成功のメッセージを設定
        const changeAddMessage: ListAddMessage = {
            mp_id: searchItems.mp_id ?? 0,
            addMessage: Messages.DEVICE_LIST_ADD,
        };
        setListAddMessage(changeAddMessage);
    } else {
        setErrorMessages([ErrorMessages.DEVICE_LIST_ADD_ERROR]);
        setOpenErrorModal(true);
    }
    setAddDeviceModal(false);
};

// 検索キーワードの機器リストへの追加
const searchWordDeviceListAdd = (
    searchText: string,
    devicecList: Array<DeviceInfoRow>,
    setAddMessage: (value: string) => void,
    setErrorMessages: (values: Array<string>) => void,
    setOpenErrorModal: (value: boolean) => void,
    dispatch: AppDispatch
) => {
    if (!(searchText.length > 0)) {
        return false;
    }

    if (devicecList.length < MAX_DEVICE_COUNT) {
        setAddMessage(Messages.DEVICE_LIST_ADD);

        const addDeviceData = {
            ...INIT_DEVICE_INFO_ROW,
            searchWord: searchText,
            inputList: [{ ...INIT_DEVICE_INFO_INPUT_ROW }],
        };
        dispatch(addDeviceRow(addDeviceData));
        return true;
    } else {
        setErrorMessages([ErrorMessages.DEVICE_LIST_ADD_ERROR]);
        setOpenErrorModal(true);
        return false;
    }
};

export const SearchResultLogic = {
    addSearchResultDeviceList,
    searchWordDeviceListAdd,
};
